import { Controller } from '@hotwired/stimulus';

// Displays the selected file name next to a file input.
//
// Usage:
//   <div data-controller="file-input">
//     <input type="file"
//            data-file-input-target="input"
//            data-action="change->file-input#displayFileName">
//     <span data-file-input-target="label"
//           class="label-wording">Choose a file</span>
//   </div>
export default class FileInputController extends Controller {
  static targets = ['input', 'label'];

  displayFileName() {
    const file = this.inputTarget.files[0];
    if (file) {
      this.labelTarget.textContent = file.name;
    }
  }
}
